import React from 'react';
function TermsConditionsOther() {
  return (
    <>
      <h1 className='fs-4 fw-bold ubbe-blue pb-2'>
        Other Terms and Conditions
      </h1>

      <ol type='1'>
        <li className='text-justify py-2'>
          In tendering the cargo (“Cargo”) described herein for delivery, the
          Customer agrees to these terms and conditions of contract, which no
          agent or employee of the parties hereto may alter, and agrees that
          this bill of lading is non-negotiable and has been prepared by the
          Customer or on Customer’s behalf by the Service Provider.
        </li>
        <li className='text-justify py-2'>
          Liability
          <ol type='a'>
            <li className='text-justify py-2'>
              Exclusion – The Service Provider shall not be liable for loss,
              damage, delay or other result caused by the acts of God, the act
              or default of the Customer or consignee, misinformation from the
              Customer, the nature of the shipment, or violation by the Customer
              or consignee of any of the tariffs or regulations, shipments whose
              contents are liable to deteriorate or perish due to change in
              climate, temperature, altitude or other ordinary exposure, or
              because of the length of time in transit, which will only be
              accepted without responsibility.
            </li>
            <li className='text-justify py-2'>
              Limitation ground services
              <ol type='i'>
                <li className='text-justify py-2'>
                  Compensation for any claim for which the Service Provider is
                  liable shall not in any event exceed 2 SDR (SDR = Special
                  Drawing Rights) per kilo of the gross weight of the goods that
                  are the subject of the claim. Without prejudice to any other
                  conditions herein or other defenses available to the Service
                  Provider, in no circumstances whatsoever shall the Service
                  Provider be liable to the Customer or owner for:
                  <ol type='1'>
                    <li className='text-justify py-2'>
                      consequential or indirect loss, including loss of market,
                      except as provided for in paragraph (2);
                    </li>
                    <li className='text-justify py-2'>
                      loss of, damage to or consequential or indirect loss
                      caused by delay or deviation in connection with the
                      transport of goods in a sum in excess of twice the
                      difference between the charges invoiced by the Company and
                      amounts paid by the Service Provider to third parties for
                      transport or other service related to those goods;
                    </li>
                  </ol>
                </li>
                <li className='text-justify py-2'>
                  Amounts in excess of a maximum recoverable of 75,000 SDR's per
                  transaction.
                  <br />
                  Upon the Customer's written request, the Service Provider may
                  accept liability in excess of these limits provided the
                  Customer pays the Service Provider's additional charges for
                  such increased liability. The Customer can obtain details of
                  these charges from the Service Provider.
                </li>
              </ol>
            </li>
            <li className='text-justify py-2'>
              Limitation air cargo services
              <ol type='i'>
                <li className='text-justify py-2'>
                  If the delivery involves an ultimate destination or stop in a
                  country other than the country of departure, the Montreal
                  Convention 1999 may be applicable and the convention governs
                  and, in most cases, limits the liability of the Service
                  Provider in respect of loss, damage or delay of the Cargo to
                  CAD $1.10 Per Kilogram, unless a higher value is declared in
                  advance by the Customer and a supplementary charge paid if
                  required.
                </li>
                <li className='text-justify py-2'>
                  In delivery to which the Montreal Convention 1999 does not
                  apply, the Service Provider’ liability in the event of loss,
                  damage or delay, whether it be caused by the negligence of the
                  Service Provider or otherwise, is limited to CAD $1.10 per
                  kilogram unless a higher value is declared on the air waybill.
                  The Service Provider shall not be liable for any consequential
                  or special damages including, but not limited to, loss of
                  profits or incomes, whether or not the Service Provider had
                  knowledge that such damages might be incurred.
                </li>
              </ol>
            </li>
            <li className='text-justify py-2'>
              Air Shipments of Extraordinary Value – special rules and
              limitations apply pursuant to the domestic air cargo tariff of the
              carrier selected by the Service Provider.
            </li>
            <li className='text-justify py-2'>
              Limitation marine services
              <ol type='i'>
                <li className='text-justify py-2'></li>
              </ol>
            </li>
            <li className='text-justify py-2'>
              Insurance – Insurance on the Cargo, is available upon request to
              the Service Provider, but shall not be provided unless explicitly
              stated on the booking instructions.
            </li>
          </ol>
        </li>
        <li className='text-justify py-2'>
          Claims against the Service Provider must be made in writing within 120
          days from the date of issue of the bill of lading. Claims for
          overcharges must be made in writing within 180 days from the date of
          issue of the bill of lading. Damage and/or loss discovered by the
          Customer after delivery and after a clear receipt has been given to
          the Service Provider at destination must be reported to the Service
          Provider in writing within 15 days after delivery of the shipment. No
          claim for loss, damage or delay to a shipment will be entertained
          until all transportation charges have been paid.
        </li>

        <li className='text-justify py-2'>
          The Service Provider shall make reasonable efforts to comply with any
          special instructions given by the Customer, but make no warranty and
          provide no guarantee that special instructions will be complied with.
        </li>
        <li className='text-justify py-2'>
          If the weight and dimension provided during the order process are
          different than what is received by the Service Provider and that
          discrepancy leads to a change in the Service Provider’ fees for the
          delivery, the Service Provider reserves the right to hold your Cargo
          until the additional fees are paid by the Customer.
        </li>
        <li className='text-justify py-2'>
          The ubbe Privacy Policy, which form part of these Terms and Conditions
          governs the use of information acquired from the Customer through ubbe
          by the Service Provider and is available from BBE Expediting Ltd. upon
          request. The Service Provider shall at all times adhere to the
          Personal Information Protection and Electronic Documents Act (PIPEDA),
          SC 2000, c. 5.
        </li>
        <li className='text-justify py-2'>
          All content contained within the site is owned by the Service
          Provider. ubbe is provided for the sole use of providing an online
          shipping service to quote, ship and track goods.
        </li>
        <li className='text-justify py-2'>
          Data. - All data collected from the Customer and in regard to the
          Delivery shall be the exclusive property of the Service Provider and
          may be stored, used and shared by the Service Provider and others for
          marketing purposes, you hereby consent to the use and disclosure of
          such collected information.
        </li>
        <li className='text-justify py-2'>
          Force Majeure. - If the Service Provider is prevented from or delayed
          in their performance of any services contracted for with the Customer
          as a result of fire, floods, epidemics, inclement weather, an act of
          God or of the public enemy, an order of a government authority, or a
          labour dispute, the time for performance of that service shall be
          extended by the length of time it is so prevented or delayed. If any
          event of force majeure that:
          <ol type='a'>
            <li className='text-justify py-2'>
              disrupts, or threatens to disrupt, the Service Provider’s
              operations; or
            </li>
            <li className='text-justify py-2'>
              if the event of force majeure lasts for more than thirty (30)
              days; or{' '}
            </li>
            <li className='text-justify py-2'>
              if the event of force majeure results in the frustration of the
              delivery ordered by the Customer, the Service Provider may cancel
              this delivery agreement by written notice, termination all
              obligations and liabilities imposed on it by this delivery
              agreement except for the obligation to pay the reasonable costs
              and expenses incurred by the Service Provider in the course of its
              performance of this delivery agreement prior to such notice of
              cancellation, not to exceed the price to be paid by the Customer
              hereunder for such cancelled delivery. The Service Provider shall
              notify the Customer of the delay in writing as soon as reasonably
              possible (and in no event later than five (5) days after the
              beginning of any cause for delay).
            </li>
          </ol>
        </li>
        <li className='text-justify py-2'>
          Delivery. - Nothing stated in these terms and conditions or any verbal
          estimate as to the delivery timing of the Cargo should ever be
          interpreted as a guarantee or assurance of delivery time. Delivery
          pursuant to the Customer’s instructions will begin as soon as is
          practical for the Service Provider and delivery will be affected when
          reasonably practical to do so, given all the circumstances of the
          delivery, the Cargo and the Service Provider.
          <ol type='a'>
            <li className='text-justify py-2'>
              All delivered or pickups done outside of the regular business
              hours of carriers are subject to a surcharge and an extra
              positioning. This charge will be the responsibility of the
              Customer.
            </li>
            <li className='text-justify py-2'>
              When a pick up or delivery is not completed outside of original
              conditions or if the circumstances prevent the pickup or delivery,
              additional surcharges may apply. This charge will be the
              responsibility of the Customer.
            </li>
            <li className='text-justify py-2'>
              When a second delivery address applies, or modifications are made
              to the original delivery address during delivery additional
              charges may apply. This charge will be the responsibility of the
              Customer.
            </li>
          </ol>
        </li>
        <li className='text-justify py-2'>
          Carrier Services & Charges for Full truckload Carriers- Should the
          Customer select a Full truckload carrier where a trailer was ordered
          and not used additional charges may apply.
          <ol type='a'>
            <li className='text-justify py-2'>
              Full truckload shipments moving in the province of Quebec during
              the thaw period may be restricted to lower weight limits where
              prices may vary.
            </li>
          </ol>
        </li>
        <li className='text-justify py-2'>
          No Guarantee or Warranty. - The Service Provider expressly disclaims
          all representations, warranties, or conditions of any kind with
          respect to the delivery services provided hereunder, whether express
          or implied, including, but not limited to, the implied warranties or
          conditions of condition, delivery time, merchantability, fitness for a
          particular purpose, accuracy, completeness, performance, system
          integration, quiet enjoyment, title, and non-infringement. The Service
          Provider does not warrant that the delivery services will meet the
          Customer’s requirements or be uninterrupted, timely, secure, or
          error-free, or that defects will be corrected. No verbal estimate as
          to the effectiveness of the Delivery should ever be interpreted as a
          guarantee of results.
        </li>
        <li className='text-justify py-2'>
          The Customer shall indemnify the Service Provider against all duties,
          taxes, payments, fines, expenses, losses, claims and liabilities,
          including without limitation any storage, demurrage, port, or terminal
          charges and any liability to indemnify any other person against claims
          made against such other person by the Customer or by a third party:
          <ol type='a'>
            <li className='text-justify py-2'>
              for which the Service Provider may be held responsible unless
              caused or contributed to by any negligence or breach of duty of
              the Service Provider, or
            </li>
            <li className='text-justify py-2'>
              in excess of the liability of the Service Provider in accordance
              with these Conditions,
            </li>
          </ol>
          resulting from or connected with the actions of the Service Provider
          related to any service to which these Conditions apply.
        </li>
        <li className='text-justify py-2'>
          Illegal Shipments and Unsafe or Dangerous Cargo. - The Service
          Provider reserves the right to terminate any delivery at any time if
          the Customer, Cargo, or delivery of the Cargo becomes unsafe in the
          sole opinion of the Service Provider or their agents, or if the
          Service Provider become aware of a contravention of any laws,
          regulations, rule or procedures applicable herein. Under no
          circumstances shall the Service Provider be liable to the Customer or
          any third party for anything resulting from the delivery of illegal,
          unsafe or dangerous Cargo (as judged in the sole discretion of the
          Service Provider acting reasonably) and the Customer shall save
          harmless and indemnify the Service Provider for all losses, claims and
          expenses related thereto.
        </li>
        <li className='text-justify py-2'>
          Choice of Law. – These Terms and Conditions shall be governed by the
          laws of the Province of Alberta and the laws of Canada applicable
          therein and the parties hereby irrevocably attorn to the exclusive
          jurisdiction of the courts of Alberta.
        </li>
        <li className='text-justify py-2'>
          No Waiver. - The silence, failure or delay by a party in exercising
          any right hereunder shall under no circumstances be interpreted or
          construed as a waiver of such right by said party; the latter may
          avail itself of such right until such time as it contractually or
          legally expires.
        </li>
        <li className='text-justify py-2'>
          Interest. - The Service Provider can charge 1.5% per month (18% per
          annum), on overdue accounts.
        </li>
      </ol>
    </>
  );
}

export default TermsConditionsOther;
